import { useLocation, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useFetch from "../Utility/useFetch";
import WorkoutLift from "./WorkoutLift";
import {
  AuthTokenRetrieve,
  LoginButton,
  LogoutButton,
} from "../Utility/AuthTokenRetrieve";
import { apiFetch, buildApiUrl } from "../Utility/api";
const WorkoutView = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id: workoutIdParam } = useParams();
  const [showCreateDiv, setShowCreateDiv] = useState(false);
  const [recentLift, setRecentLift] = useState();
  const [inputs, setInputs] = useState({});
  const [workoutLifts, setWorkoutLifts] = useState([]);
  const [saveError, setSaveError] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const workoutId = workoutIdParam || location?.state?.id;
  const { data, isPending, error } = useFetch({
    url: buildApiUrl("/workout/server/getLifts/" + workoutId),
    skip: !workoutId,
  });
  const [shouldShow, setShouldShow] = useState();

  let { shouldShow: shouldShowGoogle } = AuthTokenRetrieve();
  useEffect(() => {
    setShouldShow(shouldShowGoogle);
    if (!workoutId) {
      navigate("/workout");
      return;
    }
    if (error) {
      console.log(error);
      navigate("/workout");
    }
    if (data) {
      setWorkoutLifts(data.workoutlifts);
    }
  }, [data, error, navigate, shouldShowGoogle, workoutId]);
  const handleLiftChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
    apiFetch("/workout/recentLift/" + event.target.value)
      .then((res) => {
        return res.json();
      })
      .then((result) => {
        setRecentLift(result);
      })
      .catch((err) => {});
  };
  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };
  const saveLift = () => {
    if (!inputs.Lift || inputs.Lift === "-" || !inputs.Weight || !inputs.Reps || !inputs.Sets) {
      setSaveError("Please complete all lift fields before saving.");
      return;
    }

    setIsSaving(true);
    setSaveError("");
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        workoutId,
        method: "New Lift",
        reps: inputs.Reps,
        weight: inputs.Weight,
        sets: inputs.Sets,
        lift: inputs.Lift,
      }),
    };
    apiFetch("/workout/server/", requestOptions)
      .then((response) => response.json())
      .then((data) => {
        if (data && data.resp === "success") {
          setInputs({});
          setRecentLift(undefined);
          setShowCreateDiv(false);
          setWorkoutLifts([...workoutLifts, inputs]);
        } else {
          setSaveError("The lift could not be saved.");
        }
      })
      .catch((fetchError) => {
        setSaveError("The lift could not be saved.");
      })
      .finally(() => {
        setIsSaving(false);
      });
  };
  return (
    <div style={{ width: "100%" }}>
      {!showCreateDiv && (
        <div style={{ paddingTop: "10px" }}>
          {shouldShow ? (
            <button
              className="summaryButton fullWidthButton"
              onClick={() => setShowCreateDiv(true)}
            >
              Add Lift
            </button>
          ) : (
            <LoginButton setShouldShow={setShouldShow}></LoginButton>
          )}
        </div>
      )}
      {showCreateDiv && (
        <div className="addLiftDiv">
          <div>
            <div>
              <label>Lift</label>
              <select
                type="Select"
                className="inputBox"
                value={inputs.Lift || ""}
                name="Lift"
                onChange={handleLiftChange}
              >
                <option>-</option>
                {data &&
                  data.lifts.map((lift) => {
                    return <option key={lift.Name}>{lift.Name}</option>;
                  })}
              </select>
            </div>
          </div>

          <div>
            <div className="inputDiv">
              <label>Weight(lbs)</label>
              <input
                type="number"
                name="Weight"
                className="inputBox"
                style={{ backgroundColor: "#ebe1e8" }}
                value={inputs.Weight || ""}
                onChange={handleChange}
              />
            </div>
            <div className="inputDiv">
              <label>Reps</label>
              <input
                type="number"
                name="Reps"
                className="inputBox"
                style={{ backgroundColor: "#ebe1e8" }}
                value={inputs.Reps || ""}
                onChange={handleChange}
              />
            </div>

            <div className="inputDiv">
              <label>Sets</label>
              <input
                type="number"
                name="Sets"
                className="inputBox"
                style={{ backgroundColor: "#ebe1e8" }}
                value={inputs.Sets || ""}
                onChange={handleChange}
              />
            </div>
          </div>
          {recentLift &&
          <div className="table-container workoutRecentTable">
            <table className="modern-table">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Weight</th>
                  <th>Reps</th>
                  <th>Sets</th>
                </tr>
              </thead>
              <tbody>
                {recentLift.map((lift) => {
                  return (
                    <tr key={lift.Date}>
                      <td>{lift.Date.split(' ')[0]}</td>
                      <td>{lift.Weight}</td>
                      <td>{lift.Reps}</td>
                      <td>{lift.Sets}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
           }
          <div>
         
            <button
              style={{ margin: "auto 0px auto auto" }}
              className="summaryButton"
              onClick={() => setShowCreateDiv(false)}
            >
              Cancel
            </button>
            <button
              style={{ margin: "auto auto auto 10px" }}
              className="summaryButton actionButton"
              onClick={saveLift}
              disabled={isSaving}
            >
              {isSaving ? "Saving..." : "Save"}
            </button>
          </div>
          {saveError ? <p className="workoutErrorMessage">{saveError}</p> : null}
        </div>
      )}
      {workoutLifts &&
        workoutLifts.map((lift) => {
          return <WorkoutLift key={lift.Lift} lift={lift}></WorkoutLift>;
        })}
    </div>
  );
};
export default WorkoutView;
